import { useState } from 'react';
import { Modal } from '@/components/Modal';
import { Button } from '@/components/ui';
import type { IndicatorHelp } from './indicatorHelp';

/**
 * 지표 옆의 물음표. 누르면 풀어 쓴 설명이 뜬다. (3.11)
 *
 * 툴팁이 아니라 모달인 이유
 *   설명이 서너 문단이다. 툴팁에 넣으면 폰에서 화면을 덮고,
 *   스크롤이 안 되어 뒷부분이 잘린다. 마우스가 없는 기기에서는
 *   hover 자체가 없어 열 방법도 마땅치 않다.
 *
 * 🔴 아이콘만 두지 않고 aria-label 을 붙인다
 *   "?" 하나만 있으면 스크린리더가 "물음표 버튼" 이라고만 읽는다.
 *   무엇에 대한 설명인지가 빠진다.
 *
 * 배경은 brand-weak 다 (2026-08-28 사용자 요청 - "눈에 잘 띄게").
 *   테두리만 있던 이전 모양은 본문에 묻혀서 도움말이 있는 줄 몰랐다.
 *   토큰이라 다크 모드 값은 index.css 가 알아서 바꾼다.
 */
// 🔴 아이콘은 언제나 ? 다 - 프로젝트 전체의 도움말 표식을 통일한다 (2026-09-16 사용자 확인. 돋보기 옵션을 넣었다가 되돌림)
export function HelpButton({ help }: { help: IndicatorHelp }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={`${help.label} 설명 보기`}
        className="ml-1 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-brand-weak text-[10px] font-semibold leading-none text-brand transition-colors hover:bg-brand hover:text-brand-fg"
      >
        ?
      </button>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm:max-w-lg"
        labelledBy="help-title"
      >
        <div className="p-4 sm:p-5">
          <div className="mb-3 flex items-start justify-between gap-2">
            <h2 id="help-title" className="text-base font-semibold text-fg">
              {help.label}
            </h2>
            <Button variant="ghost" onClick={() => setOpen(false)} aria-label="닫기">
              ✕
            </Button>
          </div>

          <div className="flex flex-col gap-3">
            {help.detail.map((paragraph) => (
              <p key={paragraph} className="text-sm leading-relaxed text-fg-muted">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
}
